import { atom } from "recoil";
import { ILeasedEquipStatus } from "../Types";

export const addStateStatus = atom({
  key: "addStateStatus",
  default: false,
});
export const editStateStatus = atom({
  key: "editStateStatus",
  default: false,
});
export const rowEditStatus = atom<ILeasedEquipStatus | undefined>({
  key: "rowEditStatus",
  default: undefined,
});

export const selectedRowsStateStatus = atom<ILeasedEquipStatus[]>({
  key: "selectedRowsStateStatus",
  default: [],
});

export const statusFilterText = atom({
  key: "statusFilterText",
  default: "",
});

export const savingStatus = atom({
  key: "savingStatus",
  default: false,
});
export const statusFetching = atom({
  key: "statusFetching",
  default: true,
});
